import { render, staticRenderFns } from "./FormInputComponent.vue?vue&type=template&id=2006933e&name=component-name&"
import script from "./FormInputComponent.vue?vue&type=script&lang=js&"
export * from "./FormInputComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormInputComponent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports